import React from 'react';

interface TrendCellProps {
	trend: string;
	/** Redesign (flag on): spike colours, muted zero. */
	redesign?: boolean;
}

export const TrendCell = ({ trend, redesign = false }: TrendCellProps) => {
	const value = parseFloat(trend);
	if (isNaN(value)) {
		return <>{trend}</>;
	}
	if (redesign) {
		if (value > 0) {
			return <b style={{ color: '#c92a2a' }}>+{trend}</b>;
		}
		if (value < 0) {
			return <b style={{ color: '#2b8a3e' }}>{trend}</b>;
		}
		return <span style={{ color: '#97a0ac' }}>{trend}</span>;
	}
	if (value < 0) {
		return <b style={{ color: 'green' }}>{trend}</b>;
	} else if (value > 0) {
		return <b style={{ color: 'red' }}>+{trend}</b>;
	} else {
		return <>{trend}</>;
	}
};
